import { ArrowRight } from "components/icons/generated";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import { SelectOption } from "ds/components/Select/types";
import Typography from "ds/components/Typography";

export const LOST_FEATURES_SUMMARY_ITEMS = [
  {
    label: "Public workers",
    value: (
      <Box gap="medium">
        <Typography tag="p" variant="p-body3">
          2
        </Typography>
        <Icon src={ArrowRight} />
        <Typography tag="p" variant="p-body3" color="danger">
          1
        </Typography>
      </Box>
    ),
  },
  {
    label: "Users",
    value: (
      <Box gap="medium">
        <Typography tag="p" variant="p-body3">
          10
        </Typography>
        <Icon src={ArrowRight} />
        <Typography tag="p" variant="p-body3" color="danger">
          2
        </Typography>
      </Box>
    ),
  },
];

export const LOST_FEATURES = [
  {
    text: "Private module registry",
    negative: true,
  },
  {
    text: "OIDC integrations",
    negative: true,
  },
  {
    text: "Webhooks",
    negative: true,
  },
  {
    text: "Notifications",
    negative: true,
  },
  { text: "Spaces (multitenancy)", negative: true },
  { text: "Policy as  Code", negative: true },
];

const CANCEL_SUBSCRIPTION_REASONS = [
  "Not using the product",
  "Only need the free subscription features",
  "Lost budget for this product",
  "Switched to an alternate solution",
  "Other",
];

export const CANCEL_SUBSCRIPTION_REASONS_SELECT_OPTIONS: SelectOption[] =
  CANCEL_SUBSCRIPTION_REASONS.map((reason) => ({ value: reason, label: reason }));
